import React from 'react';
import { motion } from 'framer-motion';
import { loadWrap, loadChild, loadChildRight } from './motion';

interface LoadProps {
  children: any;
  [propName: string]: any;
}
export const LoadWrap: React.FC<LoadProps> = ({ children, ...props }) => {
  return (
    <motion.div variants={loadWrap} {...props} initial="closed" animate="open">
      {children}
    </motion.div>
  );
};

export const LoadChild: React.FC<LoadProps> = ({ children, ...props }) => {
  return (
    <motion.div variants={loadChild} {...props}>
      {children}
    </motion.div>
  );
};

export const LoadChildRight: React.FC<LoadProps> = ({ children, ...props }) => {
  return (
    <motion.div variants={loadChildRight} {...props}>
      {children}
    </motion.div>
  );
};
